import { render, staticRenderFns } from "./SvgIcons.vue?vue&type=template&id=a1413508&scoped=true&"
import script from "./SvgIcons.vue?vue&type=script&lang=js&"
export * from "./SvgIcons.vue?vue&type=script&lang=js&"
import style0 from "./SvgIcons.vue?vue&type=style&index=0&id=a1413508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1413508",
  null
  
)

export default component.exports